import axios from 'axios';
import { API_BASE_URL } from '../../../constants';
import { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { getCloudImageUrl } from 'utils';
import { TProductData } from './definitions';
import { convertBrandNameToSlug } from 'utils/Helpers';

export function useFetchCollectionData(
  category: string,
  slug: string,
  per_page: number,
  isPreverified?: boolean,
) {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [data, setData] = useState<TProductData[]>([]);

  useEffect(() => {
    setIsFetching(true);
    axios
      .get(
        category
          ? `${API_BASE_URL}/collections/${category}/${slug}?${
              category !== 'all' ? `category=${category}&` : ''
            }availables=true&per_page=${per_page}${
              isPreverified ? '&pre_verified=true&sort_by=price_asc' : ''
            }`
          : `${API_BASE_URL}/collections/${slug}?${
              category !== 'all' ? `category=${category}&` : ''
            }availables=true&per_page=${per_page}${
              isPreverified ? '&pre_verified=true&sort_by=price_asc' : ''
            }`,
      )
      .then((res) => {
        if (res.data.data.products.data.length === 0) return;

        const newValue = res.data.data.products.data.map((product) => {
          const isOnlyKickPoint = product?.variant_payment_methods?.length === 1 && !!product?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point");

          const brand = product?.product?.brand;
          const brandSlug = brand?.flat?.[0] ? convertBrandNameToSlug(brand?.flat?.[0]) : brand?.slug;
          return {
            title: product.display_name,
            price: product.price,
            image: getCloudImageUrl(product.product_variant_images[0].URL, 300),
            category: product.product.category.name,
            id: product.id,
            slug: product.slug,
            isOnlyKickPoint,
            brand: brandSlug
          };
        });

        setData(newValue);
        setIsFetching(false);
      })
      .catch((err) => {
        console.error('failed to fetch', err);
        setIsFetching(false);
      });
  }, [isPreverified, category, slug]);

  return {
    isFetching,
    data,
  };
}
